import React from 'react';

function ExperiencedProfessionals({ setView }) {
  const handleQuoteClick = (e) => {
    e.preventDefault();
    const contactForm = document.querySelector('.contact-section') || document.getElementById('contact-form');
    if (contactForm) {
      contactForm.scrollIntoView({ behavior: 'smooth' });
    } else if (setView) {
      window.history.pushState({}, '', '/contact/');
      setView('contact');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  return (
    <section className="experienced-professionals-section">
      <div className="container experienced-professionals-container">
        {/* Left Column: Text & CTA */}
        <div className="experienced-professionals-left">
          <h2 className="experienced-professionals-title">
            Experienced Professionals Delivering Success
          </h2>
          
          <p className="experienced-professionals-desc">
            For sustainable growth, businesses operating in Pakistan require strong technological infrastructure and good operational efficiency. At Experts Communications, we bring together experienced professionals from across the spectrum of IT and BPO companies to deliver success for your organization. We use deep industry knowledge and proven methodologies to provide customized solutions that address your unique challenges and drive real results.
          </p>
          
          <p className="experienced-professionals-desc">
            Beyond our core IT and BPO offerings, we understand the important role of a strong online presence in present day market. Our expertise extends from digital marketing services to web development and web design services, for your brand to reach the right audience and achieve its online objectives. We combine our IT and BPO solutions with strategic digital marketing to create a reliable approach. We aim to expand your growth and maximize your ROI. Connect with our experienced professionals today to explore how we can deliver success for your business.
          </p>
          
          <button className="btn-quote btn-free-quote" onClick={handleQuoteClick}>
            Get Free Quote
          </button>
        </div>

        {/* Right Column: Image */}
        <div className="experienced-professionals-right">
          <img 
            src="/assets/images/experienced_professionals.png" 
            alt="Experienced Professional" 
            className="experienced-professionals-img"
          />
        </div>
      </div>
    </section>
  );
}

export default ExperiencedProfessionals;
